/**
* 返回一个数组，包含所有选中的MenuId
*/
export function getCheckedMenuId() {
    let checkedMenuArr = [];
    //被选中的二级菜单
    let ckCld = document.querySelectorAll("input[name='ck-cld']:checked");
    ckCld = [...ckCld];
    ckCld.forEach(c => checkedMenuArr.push(c.value));

    //部分选中状态的父菜单
    let cParent = document.querySelectorAll(".ant-checkbox-indeterminate input[name='ck-all']");
    cParent = [...cParent];
    cParent.forEach(c => checkedMenuArr.push(c.value));

    //全选中状态的父菜单
    let cParent1 = document.querySelectorAll("input[name='ck-all']:checked");
    cParent1 = [...cParent1];
    cParent1.forEach(c => checkedMenuArr.push(c.value));
    //不含子菜单的一级菜单
    let cOnly = document.querySelectorAll(".ant-checkbox-input[name='ck-only']:checked");
    cOnly = [...cOnly];
    cOnly.forEach(c => checkedMenuArr.push(c.value));
    return checkedMenuArr.sort();
}